export const STANDARD_CATEGORY_ORDER = [
    'County', 'Regional', 'National', 'International', 'Other'
];
export function getStandardCategory(name) {
    const normalized = name.toLowerCase();
    if (normalized.includes('international') || normalized.includes('ssa'))
        return 'International';
    if (normalized.includes('national') || normalized.includes('british') || normalized.includes('fina'))
        return 'National';
    if (normalized.includes('london') || normalized.includes('regional') || normalized.includes('se '))
        return 'Regional';
    if (normalized.includes('custom'))
        return 'Other';
    return 'County';
}
;
